const RESTRICTED_COLLECTIONS_PRODUCTION = [
  {
    id: '5e0f3c5b03b7ad0924ef0ab0',
    name: 'KDS Spanish Bank',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0acb',
    name: 'KDS NGSS',
    replaceEnabled: true,
  },
  {
    id: '610162c600dce400097b552a',
    name: 'KDS Quick Checks',
    replaceEnabled: true,
  },
  {
    id: '628696ec600887000a53417a',
    name: 'KDS Multilingual',
    replaceEnabled: true,
  },
  {
    id: '647ee28edfd5a40008f9a67f',
    name: 'KDS - Custom',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0aa8',
    name: 'KDS Inspect Bank',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0abe',
    name: 'Inspect 18-19',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ac4',
    name: 'Inspect Item Bank',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0acd',
    name: 'Inspect Alabama',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ace',
    name: 'Inspect Arizona',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0acf',
    name: 'Inspect Common Core',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad1',
    name: 'Inspect Colorado',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad2',
    name: 'Inspect Florida',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad4',
    name: 'Inspect Georgia',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad5',
    name: 'Inspect Hawaii',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad6',
    name: 'Inspect Indiana',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad7',
    name: 'Inspect Kansas',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad8',
    name: 'Inspect Louisiana',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad9',
    name: 'Inspect Massachusetts',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ada',
    name: 'Inspect Missouri',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0adb',
    name: 'Inspect New Jersey',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0add',
    name: 'Inspect Ohio',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ade',
    name: 'Inspect Pennsylvania',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0adf',
    name: 'Inspect Tennessee',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ae0',
    name: 'Inspect Utah',
    replaceEnabled: true,
  },
  {
    id: '610002b779bee300094ec07d',
    name: 'Inspect Premium',
    replaceEnabled: true,
  },
  {
    id: '611e46755753810009f8668f',
    name: 'Inspect - Alaska',
    replaceEnabled: true,
  },
  {
    id: '611e46e074f4ed00096351f3',
    name: 'Inspect - Arkansas',
    replaceEnabled: true,
  },
  {
    id: '611e46ed6b63860009457e78',
    name: 'Inspect - California',
    replaceEnabled: true,
  },
  {
    id: '611e46f9d65cf7000a38d9dc',
    name: 'Inspect - Connecticut',
    replaceEnabled: true,
  },
  {
    id: '611e4702b7c65f00096218ff',
    name: 'Inspect - Delaware',
    replaceEnabled: true,
  },
  {
    id: '611e4712893c3d0009708b22',
    name: 'Inspect - District of Columbia',
    replaceEnabled: true,
  },
  {
    id: '611e47209d4d2300091d70e5',
    name: 'Inspect - Idaho',
    replaceEnabled: true,
  },
  {
    id: '611e472bd65cf7000a38d9f3',
    name: 'Inspect - Illinois',
    replaceEnabled: true,
  },
  {
    id: '611e47366b63860009457ea0',
    name: 'Inspect - Iowa',
    replaceEnabled: true,
  },
  {
    id: '611e47425753810009f866df',
    name: 'Inspect - Kentucky',
    replaceEnabled: true,
  },
  {
    id: '611e4753e533900009eac118',
    name: 'Inspect - Maine',
    replaceEnabled: true,
  },
  {
    id: '611e475eeebfa80009deb036',
    name: 'Inspect - Maryland',
    replaceEnabled: true,
  },
  {
    id: '611e4768e533900009eac126',
    name: 'Inspect - Michigan',
    replaceEnabled: true,
  },
  {
    id: '611e47738a6d1c0009332862',
    name: 'Inspect - Minnesota',
    replaceEnabled: true,
  },
  {
    id: '611e477ea3733e000910025b',
    name: 'Inspect - Mississippi',
    replaceEnabled: true,
  },
  {
    id: '611e478ab7c65f0009621941',
    name: 'Inspect - Montana',
    replaceEnabled: true,
  },
  {
    id: '611e47946b63860009457ed0',
    name: 'Inspect - Nebraska',
    replaceEnabled: true,
  },
  {
    id: '611e479fb7c65f0009621948',
    name: 'Inspect - Nevada',
    replaceEnabled: true,
  },
  {
    id: '611e47ab893c3d0009708bbb',
    name: 'Inspect - New Hampshire',
    replaceEnabled: true,
  },
  {
    id: '611e47ba6b63860009457ee0',
    name: 'Inspect - New Mexico',
    replaceEnabled: true,
  },
  {
    id: '611e47c7b7c65f0009621956',
    name: 'Inspect - New York',
    replaceEnabled: true,
  },
  {
    id: '611e47d23ce20d0009b45b6e',
    name: 'Inspect - North Carolina',
    replaceEnabled: true,
  },
  {
    id: '611e47dd6b63860009457efc',
    name: 'Inspect - North Dakota',
    replaceEnabled: true,
  },
  {
    id: '611e47e8a3733e000910028f',
    name: 'Inspect - Oklahoma',
    replaceEnabled: true,
  },
  {
    id: '611e47f3eebfa80009deb06d',
    name: 'Inspect - Oregon',
    replaceEnabled: true,
  },
  {
    id: '611e4800893c3d0009708c27',
    name: 'Inspect - Rhode Island',
    replaceEnabled: true,
  },
  {
    id: '611e480cc3a7470009eb1745',
    name: 'Inspect - South Carolina',
    replaceEnabled: true,
  },
  {
    id: '611e4817a3733e00091002ac',
    name: 'Inspect - South Dakota',
    replaceEnabled: true,
  },
  {
    id: '611e4826bb579400095b5875',
    name: 'Inspect - Texas',
    replaceEnabled: true,
  },
  {
    id: '611e4830eebfa80009deb07e',
    name: 'Inspect - Vermont',
    replaceEnabled: true,
  },
  {
    id: '611e483bb7c65f00096219af',
    name: 'Inspect - Virginia',
    replaceEnabled: true,
  },
  {
    id: '611e4847bb579400095b5884',
    name: 'Inspect - Washington',
    replaceEnabled: true,
  },
  {
    id: '611e4852e533900009eac192',
    name: 'Inspect - West Virginia',
    replaceEnabled: true,
  },
  {
    id: '611e485dc3a7470009eb176f',
    name: 'Inspect - Wisconsin',
    replaceEnabled: true,
  },
  {
    id: '611e4867ea75ff000ab4360b',
    name: 'Inspect - Wyoming',
    replaceEnabled: true,
  },
  {
    id: '637272e6758a9d000768903c',
    name: 'Inspect - GCPS',
    replaceEnabled: true,
  },
  {
    id: '63f305275080d300081a71a0',
    name: 'Inspect GCPS Review Parent Bank',
    replaceEnabled: true,
  },
  {
    id: '6499a52af1c8330008b55092',
    name: 'Inspect GCPS A&A Restricted Bank',
    replaceEnabled: true,
  },
  {
    id: '649c1fe8941922000871f2f9',
    name: 'Inspect GCPS Teacher Bank',
    replaceEnabled: true,
  },
]

const RESTRICTED_COLLECTIONS_DRYRUN = [
  {
    id: '5e0f3c5b03b7ad0924ef0aa8',
    name: 'KDS Inspect Bank',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0acb',
    name: 'KDS NGSS',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ab0',
    name: 'KDS Spanish Bank',
    replaceEnabled: true,
  },
  {
    id: '64882ac732e9e80008f9273d',
    name: 'CFA KDS',
    replaceEnabled: true,
  },
  {
    id: '64d234605ed4b71a62162783',
    name: 'CFA KDS TEST',
    replaceEnabled: true,
  },
  {
    id: '64d362fcf9668a816692a6b8',
    name: 'KDS Inspect Bank',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0abe',
    name: 'Inspect 18-19',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ac4',
    name: 'Inspect Item Bank',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0acd',
    name: 'Inspect Alabama',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ace',
    name: 'Inspect Arizona',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0acf',
    name: 'Inspect Common Core',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad1',
    name: 'Inspect Colorado',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad2',
    name: 'Inspect Florida',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad4',
    name: 'Inspect Georgia',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad5',
    name: 'Inspect Hawaii',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad6',
    name: 'Inspect Indiana',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad7',
    name: 'Inspect Kansas',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad8',
    name: 'Inspect Louisiana',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ad9',
    name: 'Inspect Massachusetts',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ada',
    name: 'Inspect Missouri',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0adb',
    name: 'Inspect New Jersey',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0add',
    name: 'Inspect Ohio',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ade',
    name: 'Inspect Pennsylvania',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0adf',
    name: 'Inspect Tennessee',
    replaceEnabled: true,
  },
  {
    id: '5e0f3c5b03b7ad0924ef0ae0',
    name: 'Inspect Utah',
    replaceEnabled: true,
  },
  {
    id: '63736553c8759e000816c97d',
    name: 'Inspect Plus',
    replaceEnabled: true,
  },
  {
    id: '6375f0b9e9373d0008c40f58',
    name: 'Inspect Premium',
    replaceEnabled: true,
  },
  {
    id: '63f37196471d190008bebc2b',
    name: 'Inspect Pending Items',
    replaceEnabled: true,
  },
  {
    id: '64d38a455017af5d4976c94f',
    name: 'Inspect Item Bank ',
    replaceEnabled: true,
  },
]

module.exports = {
  RESTRICTED_COLLECTIONS_PRODUCTION,
  RESTRICTED_COLLECTIONS_DRYRUN,
}
